<template>
  <p>
    <span style="font-size: 24px; font-weight: 700"> </span>
  </p>

  <br />
  <table cellspacing="0" class="tab-1" style="margin-top: -120px">
    <tbody>
      <tr>
        <td
          style="
            background-color: #d9d9d9;
            border-bottom: 1px solid black;
            border-left: 1px solid black;
            border-right: 1px solid black;
            border-top: 1px solid black;
            vertical-align: top;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">개인정보 항목</span>
            </span>
          </p>
        </td>
        <td
          style="
            background-color: #d9d9d9;
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: 1px solid black;
            vertical-align: top;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">수집/이용 목적</span>
            </span>
          </p>
        </td>
        <td
          style="
            background-color: #d9d9d9;
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: 1px solid black;
            vertical-align: top;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">보유 및 이용기간</span>
            </span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: none;
            vertical-align: middle;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">
                이름, 휴대폰번호, 이메일주소
              </span>
            </span>
          </p>
        </td>
        <td
          style="
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: none;
            vertical-align: middle;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">
                이벤트 운영 및 광고성 정보 전송
              </span>
            </span>
          </p>
        </td>
        <td
          style="
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: none;
            vertical-align: middle;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">
                <span style="font-weight: 700; text-decoration: underline"
                  >철회하거나 목적 달성 또는 탈퇴시까지</span
                >
              </span>
            </span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <!-- <p style="margin-left: -50px"> -->
  <p>
    <span style="font-size: 16px">
      ※ 귀하는 마케팅 정보 수신 여부 및 마케팅을 위한 개인정보 수집이용을
      거부하실 수 있으며, 거부하시는 경우에도 서비스를 이용하실 수 있으나,
      동의를 거부한 경우 각종 소식 및 이벤트 참여에 제한이 있을 수 있습니다
    </span>
  </p>
</template>
